module.exports = require("ky-universal");